import { EditorState, Transaction } from 'prosemirror-state';
import { schema } from '../schema';

type Dispatch = (tr: Transaction) => void;

/**
 * Convert a task node to a paragraph, preserving content.
 * Used when backspace is pressed at the start of a task.
 */
export function convertTaskToParagraph(
  state: EditorState,
  dispatch?: Dispatch
): boolean {
  const { $from } = state.selection;
  const parent = $from.parent;

  if (parent.type.name === 'task' && $from.parentOffset === 0) {
    dispatch?.(state.tr.setNodeMarkup($from.before(), schema.nodes.paragraph));
    return true;
  }
  return false;
}

/**
 * Handle Enter key in a task node.
 * - Empty task: convert to paragraph
 * - Non-empty task: split and create new task
 */
export function handleTaskEnter(
  state: EditorState,
  dispatch?: Dispatch
): boolean {
  const { $from } = state.selection;
  const parent = $from.parent;

  if (parent.type.name !== 'task') {
    return false;
  }

  // Empty task: convert to paragraph
  if (parent.content.size === 0) {
    dispatch?.(state.tr.setNodeMarkup($from.before(), schema.nodes.paragraph));
    return true;
  }

  // Non-empty task: split and create new task
  dispatch?.(
    state.tr.split($from.pos, 1, [
      { type: schema.nodes.task, attrs: { done: false, active: false } },
    ])
  );
  return true;
}
